
export default class Gallery {

	static getHolderSelectors = () => ['section.gallery'];


	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		new LuminousGallery(holderElement.querySelectorAll('.luminous-image'));
	}
}
